module.exports = __webpack_public_path__ + "static/media/license01.7fe0b159.jpg";